<!-- components/SpotIndices.vue -->
 <!-- BR#158	add a pop-up on ICM Access for spot indices 12/02/2025 Mbeng-->
   
<template>
  <div
    v-if="visible"
   class="popup-overlay"
  >
    <!-- Popup -->
    <div
      class="popup-content"
    >
      
      <div>
        <h2 style="font-weight:bold" v-html="$t('popup-important-notice ')"></h2><br>
        <p  v-html="$t('popup-please-be-advised-that-margin-requirements-for-certain-spot')"></p>
        <p  v-html="$t('popup-affected-instruments')"></p>
        <p  v-html="$t('popup-this-change-will-apply-to-all-open-positions') "></p>
        <p  v-html="$t('popup-alternative-option')"></p><br>
        
      <button
        @click="$emit('close')"
        class="text-white font-bold bg-opacity-50 hover:bg-opacity-80 rounded-full p-2 z-10"
        style="background-color: #004A81;"
      >
      {{ $t('i-understand') }}
      </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SpotIndices",
    props: {
    visible: {
      type: Boolean,
      required: true
    },
  },
  emits: ["close"],
  data() {
    return {
    };
  },
  computed: {
     ...mapGetters(["get_profile", "get_user_data"]),
    userLanguage() {
    return this.get_profile?.profile?.language;
  }
  },

  methods: {
    
  },

};
</script>
<style scoped>
/* Simple popup styles */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-content {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  width: 400px;
  text-align: center;
}
</style>
